import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'toggle-text',
  templateUrl: './toggle-text.component.html',
  styleUrls: ['./toggle-text.component.scss'],
  standalone: false,
})
export class ToggleTextComponent {
  @ViewChild('container') $container!: ElementRef;
  @Input() text = '';
  @Input() qtyWord = 50;

  getPartOfString(text: string, index: number) {
    const newText = text.split(' ');

    if (index === 1) {
      return newText.slice(0, this.qtyWord).join(' ');
    }

    return newText.slice(this.qtyWord, newText.length).join(' ');
  }

  toggleText() {
    const $container = this.$container.nativeElement as HTMLDivElement;
    $container.classList.toggle(`active`);
  }

  hasSecondPart(text: string) {
    const newText = text.split(' ');

    return newText.slice(this.qtyWord, newText.length).length > 0;
  }
}
